import { functions } from '@/plugins/firebase';
import * as userServices from '@/services/userServices';

/*** 
TODO: userの説明を追加
***/
export default {
  namespaced: true,
  state: {
    userType: '',
    birthDate: new Date(),
    nickname: '',
    photoURL: '',
    isStreaming: false,
    ivsChannelArn: '',
    ivsStreamKeyArn: '',
    recentLiveId: '',
    categories: [],
    selfIntroduction: '',
    likedPerformers: []
  },
  mutations: {
    loadUserDoc(state, payload) {
      state.userType = payload.userType;
      state.birthDate = payload.birthDate;
      state.nickname = payload.nickname;
      state.photoURL = payload.photoURL;
      state.isStreaming = payload.isStreaming;
      state.ivsChannelArn = payload.ivsChannelArn;
      state.ivsStreamKeyArn = payload.ivsStreamKeyArn;
      state.recentLiveId = payload.recentLiveId;
      state.categories = payload.categories;
      state.selfIntroduction = payload.selfIntroduction;
      state.likedPerformers = payload.likedPerformers;
    },
    updateIvsChannelArn(state, channelArn) {
      state.ivsChannelArn = channelArn;
    },
    updateIvsStreamKeyArn(state, streamKeyArn) {
      state.ivsStreamKeyArn = streamKeyArn;
    },
    updateRecentLiveId(state, recentLiveId) {
      state.recentLiveId = recentLiveId;
    },
    updateIsStreaming(state, isStreaming) {
      state.isStreaming = isStreaming;
    },
    updateDoron(state, doronAmount) {
      state.doron += doronAmount;
    },
    updateLikedPerformers(state, likedPerformers) {
      state.likedPerformers = likedPerformers;
    }
  },
  actions: {
    async loadUserDoc({ commit }, userId) {
      if (!userId) {
        return;
      }
      const userDoc = await userServices.getUserDoc(userId);
      if (!userDoc) {
        return;
      }
      commit('loadUserDoc', userDoc);
    },
    async purchaseDoron({ commit, state }, payload) {
      const createChargeMethod = functions.httpsCallable('paymentCreateCharge');
      try {
        // create Charge on PAY.jp
        await createChargeMethod(payload);
        // update user db
        await userServices.updateUserDoc(payload.userId, {
          doron: state.userDoc.doron + payload.amount
        });
        // commit state
        commit('updateDoron', payload.amount);
      } catch (err) {
        console.error(err);
        return;
      }
    },
    async loadLikedPerformers({ commit }, userId) {
      const likedPerformers = await userServices.getLikedPerformers(userId);
      commit('updateLikedPerformers', likedPerformers);
    },
    async removePerformersFromLiked({ commit }, payload) {
      const likedPerformers = await userServices.removePerformersFromLiked(
        payload.userId,
        payload.performerIds
      );
      commit('updateLikedPerformers', likedPerformers);
    }
  },
  getters: {
    isStreaming(state) {
      if (state.recentLiveId) {
        return state.recentLiveId != '';
      } else {
        return false;
      }
    },
    isPerformer(state) {
      if (state.userType) {
        return state.userType === 'performer';
      } else {
        return false;
      }
    },
    recentLiveId(state) {
      return state.recentLiveId;
    },
    likedPerformers(state) {
      return state.likedPerformers;
    }
  }
};
